import { IMessage } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

function checkIsLoadedLastMessages(group: Group, messages: (IMessage | ChatMessage)[]): boolean {
  if (!group.counter) {
    return false;
  }
  let lastMessage: ChatMessage;
  let index = messages.length;
  do {
    lastMessage = messages[--index] as ChatMessage;
  } while (lastMessage?.isFake);

  return (
    lastMessage?.serverTime >= group.counter.lastMessageTs ||
    group.messagesStore.lastMessage?.serverTime >= group.counter.lastMessageTs ||
    group.messagesStore.isLoadedLastMessages
  );
}

export function handleIsLoadedLastMessages(
  groupId: string,
  messages: (IMessage | ChatMessage)[]
): void {
  const group = Entities.GroupsStore.getGroupById(groupId);

  if (!group || group.isFake) {
    return;
  }

  const isLoadedLastMessages = checkIsLoadedLastMessages(group, messages);
  group.messagesStore.setLoadedLastMessages(isLoadedLastMessages);
}
